// extracted by mini-css-extract-plugin
module.exports = {"searchList":"QuickList_searchList__2_rv9"};